<template>
    <div>
        <div v-if="!isPdfOrImageUrl(src)" ref="imageWrapper" class="cus-image" :style="width + ';' + height" id="imgId" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
            <el-image v-if="displaySrc" style="width: 100%; height: 100%" :src="displaySrc" :fit="fit" :alt="alt" :z-index="zIndex" :preview-src-list="effectivePreviewList" @click="cusPreviewImage">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
            <div v-else class="image-slot">
                <i class="el-icon-loading"></i>
            </div>
        </div>
        <div v-else class="cus-image" :style="width + ';' + height" @click="dialogVisible = true">
            <img style="width: 100%;height:  100%;" src="../assets/Pdf.png" />
        </div>
        <el-dialog title="PDF预览" :visible.sync="dialogVisible" width="1000px" top="10px" append-to-body center>
            <iframe :src="src" frameborder="0" style="width: 950px; height: 660px"></iframe>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "cusImage",
    data() {
        return {
            dnFlag: false,
            wrapperElem: null,
            hidElClassNameLists: [
                "el-image-viewer__mask",
                "el-image-viewer__btn el-image-viewer__close",
                "el-icon-close",
            ],
            wrapperElem: null,
            dialogVisible: false,
            isVisible: false,
            loading: false,
            observer: null,
        };
    },
    props: {
        src: {
            type: String,
            default: "",
        },
        previewSrcList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        width: {
            type: String,
            default: "100%",
        },
        height: {
            type: String,
            default: "100%",
        },
        fit: {
            type: String,
            default: "",
        },
        alt: {
            type: String,
            default: "",
        },
        referrerPolicy: {
            type: String,
            default: "",
        },
        zIndex: {
            type: Number,
            default: 2000,
        },
        lazy: {
            type: Boolean,
            default: true,
        },
        scrollContainer: {
            type: [String, HTMLElement],
            default: "",
        },
    },
    computed: {
        effectivePreviewList() {
            return this.previewSrcList.length ? this.previewSrcList : (this.src ? [this.src] : []);
        },
        displaySrc() {
            if (!this.src || this.isPdfOrImageUrl(this.src)) {
                return "";
            }
            if (!this.lazy || this.isVisible) {
                return this.src;
            }
            return "";
        },
    },
    watch: {
        src() {
            if (this.lazy && !this.isVisible) {
                this.resetLazyLoad();
                return;
            }
            this.handleSrcChange();
        },
        lazy(val) {
            this.isVisible = !val;
            this.resetLazyLoad();
        },
    },
    mounted() {
        this.isVisible = !this.lazy;
        this.resetLazyLoad();
    },
    beforeDestroy() {
        this.destroyObserver();
    },
    methods: {
        resetLazyLoad() {
            this.destroyObserver();
            if (!this.lazy) {
                this.handleSrcChange();
                return;
            }
            this.$nextTick(() => {
                const el = this.$refs.imageWrapper;
                if (!el || !this.src || this.isPdfOrImageUrl(this.src)) {
                    return;
                }
                if (!window.IntersectionObserver) {
                    this.isVisible = true;
                    this.handleSrcChange();
                    return;
                }
                this.observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                this.isVisible = true;
                                this.handleSrcChange();
                                this.destroyObserver();
                            }
                        });
                    },
                    {
                        root: this.getScrollRoot(el),
                        rootMargin: "50px",
                        threshold: 0.01,
                    }
                );
                this.observer.observe(el);
            });
        },
        destroyObserver() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
        },
        getScrollRoot(el) {
            if (this.scrollContainer) {
                return typeof this.scrollContainer === "string"
                    ? document.querySelector(this.scrollContainer)
                    : this.scrollContainer;
            }
            let parent = el.parentElement;
            while (parent && parent !== document.body) {
                if (parent.classList.contains("el-table__body-wrapper")) {
                    return parent;
                }
                const style = window.getComputedStyle(parent);
                if (/(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX)) {
                    return parent;
                }
                parent = parent.parentElement;
            }
            return null;
        },
        handleSrcChange() {
            if (!this.displaySrc) {
                this.loading = false;
                return;
            }
            this.startLoading(this.displaySrc);
        },
        startLoading(src) {
            this.loading = true;
            const img = new Image();
            const currentSrc = src;
            const finishLoading = () => {
                if (this.displaySrc === currentSrc) {
                    this.loading = false;
                }
            };
            img.onload = finishLoading;
            img.onerror = finishLoading;
            img.src = src;
        },
        isPdfOrImageUrl(url) {//判断是否是PDF，返回是
            const pdfPattern = /\.pdf$/i;
            if (pdfPattern.test(url) || url.indexOf('data:application/pdf;base64') != -1) {
                return true
            } else {
                return false
            }
            // const imagePattern = /\.(jpeg|jpg|png|gif|bmp|webp)$/i;
            // return pdfPattern.test(url) || imagePattern.test(url);
        },
        print() {
            const img = new Image();
            var flag = false
            var imgsHtml = ""
            img.src = this.src
            img.onload = () => {
                console.log(img.width, img.height);
                if (img.width > img.height) {
                    flag = true
                } else {
                    flag = false
                }
                if (flag) {
                    imgsHtml = `<div style="width:210mm;height:297mm;display:flex;align-items:center;justify-content:center;page-break-after:always;overflow:hidden;">
                  <img src='${this.src}' style="transform:rotate(90deg);width:297mm;height:210mm;object-fit:contain;display:block;" />
               </div>`;
                } else {
                    imgsHtml = `<div style="width:210mm;height:297mm;display:flex;align-items:center;justify-content:center;page-break-after:always;overflow:hidden;">
                  <img src='${this.src}' style="width:210mm;height:297mm;object-fit:contain;display:block;" />
               </div>`;
                }
                const printWindow = window.open('', '_blank');
                printWindow.document.write(`
                <html>
                <head>
                    <style>
                        @page { size: A4; margin: 0; }
                        html, body { width: 210mm; height: 297mm; margin: 0; padding: 0; }
                        /* 只保留必要样式 */
                        img { object-fit: contain; display: block; margin: 0 auto; }
                    </style>
                </head>
                <body>
                    ${imgsHtml}
                    <script>
                        window.onload = function() { window.print(); window.close(); }
                    <\/script>
                </body>
                </html>
            `);
                printWindow.document.close();
            };
        },
        cusPreviewImage() {
            // this.dnFlag = true;
            this.checkElemlents();
        },
        checkElemlents() {

            this.$nextTick(() => {
                let wrapper = document.getElementsByClassName(
                    'el-image-viewer__actions__inner'
                )
                console.log(wrapper)
                if (wrapper.length > 0) {
                    let downImg = document.createElement('i')
                    downImg.setAttribute('class', 'el-icon-download')
                    let printImg = document.createElement('i')
                    printImg.setAttribute('class', 'el-icon-printer')
                    wrapper[0].appendChild(downImg)
                    wrapper[0].appendChild(printImg)
                    this.wrapperElem = wrapper[0]
                    this.cusClickHandler()
                }

            })
        },
        cusClickHandler() {
            this.wrapperElem.addEventListener("click", this.hideCusBtn);
        },
        hideCusBtn(e) {
            console.log(e);
            let className = e.target.className
            if (className === 'el-icon-download') {
                let imgUrl = document.getElementsByClassName(
                    'el-image-viewer__canvas'
                )[0].children[0].src
                console.log(document.getElementsByClassName(
                    'el-image-viewer__canvas'
                )[0].children[0].src);
                this.downloadImage(imgUrl)
            } else if (className === 'el-icon-printer') {
                this.print()
            }
        },
        dnImage() {
            let imgUrl = document.getElementsByClassName(
                "el-image-viewer__canvas"
            )[0].children[0].src;
            this.downloadImage(imgUrl);
        },
        // 下载图片，这里如果涉及到跨域需自行解决，我们设置的 CORS，文章最下方有跨域 NGINX 解决办法
        downloadImage(imgUrl) {
            let tmpArr = imgUrl.split("/");
            let fileName = tmpArr[tmpArr.length - 1];

            fetch(imgUrl)
                .then(response => response.blob())
                .then(blob => {
                    const fileUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    (document.body || document.documentElement).appendChild(a);
                    a.href = fileUrl;
                    if ("download" in a) {
                        a.download = fileName;
                    } else {
                        a.setAttribute("download", fileName);
                    }
                    a.target = "_self";
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(fileUrl); // 释放内存
                })
                .catch(err => console.error("Download failed:", err));
        },
        saveAs(data, name) {
            console.log(data, name, "12312312312")
            var urlObject = window.URL || window.webkitURL || window;
            var export_blob = new Blob([data]);
            var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
            save_link.href = urlObject.createObjectURL(export_blob);
            save_link.download = name;
            save_link.click();
        },

        /**
         * 根据文件url获取文件名
         * @param url 文件url
         */
        getFileName(url) {
            var num = url.lastIndexOf('/') + 1
            var fileName = url.substring(num)
            //把参数和文件名分割开
            fileName = decodeURI(fileName.split("?")[0]);
            return fileName;
        }
    },
};
</script>
<style scoped>
.cus-image {
    display: inline-block;
    width: 100%;
    height: 100%;
}

.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 20px;
}

.el-image-viewer__download {
    top: 40px;
    right: 100px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    z-index: 2001;
    /* 如果该组件需要传递 z-index 的值，这个值也需要做成动态的 props */
    cursor: pointer;
    position: fixed;
}

.el-image-viewer__printer {
    top: 40px;
    right: 160px;
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    z-index: 2001;
    /* 如果该组件需要传递 z-index 的值，这个值也需要做成动态的 props */
    cursor: pointer;
    position: fixed;
}
</style>